import React, { useState } from 'react';
import styles from './index.module.scss';

type Props = {
  type: 'text' | 'password';
  placeholder: string;
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  hasError?: boolean;
  errorMessage?: string;
};

const Input = (props: Props) => {
  const [passwordVisibility, setPasswordVisibility] = useState<boolean>(false);

  return (
    <div className={styles.form_group}>
      {props.label && <label className={styles.label}>{props.label}</label>}
      <input
        value={props.value}
        onChange={(element) => props.onChange(element.target.value)}
        type={passwordVisibility ? 'text' : props.type}
        placeholder={props.placeholder}
        className={`${styles.input} ${props.hasError ? styles.has_error : ''}`}
      />
      {
        props.hasError && props.errorMessage && (
          <div className={styles.error_badge}>
            {props.errorMessage}
          </div>
        )
      }
      {props.type === 'password' && (
        <img
          src={`${
            passwordVisibility
              ? '/assets/images/passwordVisible.svg'
              : '/assets/images/passwordInvisible.svg'
          }`}
          className={styles.password_eye}
          onClick={() => setPasswordVisibility(!passwordVisibility)}
          alt=""
        />
      )}
    </div>
  );
};

export default Input;
